/**
 * Vendor-imported customers (DRB, EverWash, …) use membership history instead of
 * order-based service history. Way-created customers have null/empty/`way` source.
 */
export function isVendorMembershipCustomerSource(source: string | null | undefined): boolean {
  const normalized = String(source || '')
    .trim()
    .toLowerCase();
  return Boolean(normalized) && normalized !== 'way';
}

/** Chip / badge label for a vendor membership row's `subscriptions.source`. */
export function formatVendorMembershipSourceLabel(source: string | null | undefined): string {
  const normalized = String(source || '')
    .trim()
    .toLowerCase();
  if (normalized === 'drb') {
    return 'DRB';
  }
  if (normalized === 'everwash') {
    return 'EverWash';
  }
  if (!normalized) {
    return 'Vendor';
  }
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}
